<template>
    <v-container>
        <v-row>
            <v-col
                    cols="12"
            >
                <p class="font-weight-bold text-center display-2" >
                    Thanks, {{ customer.name }}
                </p>
                <p class="text-center title">
                    Your request has been successfully registered.
                </p>
                <hr>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-card
                        :loading="loading.general"
                >
                    <v-card-title>
                        <p class="font-weight-bold subtitle-1 text-center display-2">
                            Information
                        </p>
                    </v-card-title>
                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                                <tbody>
                                <tr>
                                    <td>
                                        Order number
                                    </td>
                                    <td>
                                        {{ order.id }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Status
                                    </td>
                                    <td>
                                        {{ order.name_status }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Address {{order.status}}
                                    </td>
                                    <td>
                                        {{address.address}} - {{address.gatecode}} - {{address.city}} {{address.state}} - {{address.zipcode}}
                                    </td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
                <br>
                <div v-if="order.status == 1" ref="paypal"></div>
            </v-col>
            <v-col cols="12" md="6">
                <v-card
                        :loading="loading.general"
                >
                    <v-card-title>
                        <p class="font-weight-bold subtitle-1 text-center display-2">
                            Summary
                        </p>
                    </v-card-title>
                    <v-card-text>
                        <v-row style="font-weight: bold;" class="d-none d-sm-flex">
                            <v-col
                                    cols="5"
                                    class="text-center"
                            >
                                Product
                            </v-col>
                            <v-col
                                    cols="2"
                                    class="text-center"
                            >
                                Price
                            </v-col>
                            <v-col
                                    cols="2"
                                    class="text-center"
                            >
                                Qty
                            </v-col>
                            <v-col
                                    cols="2"
                                    class="text-center"
                            >
                                <span>Total</span>
                            </v-col>
                        </v-row>
                        <v-row v-for="(item, index) in products" :key="index">
                            <v-col
                                    cols="12"
                                    sm="5"
                                    class="text-center"
                            >
                                <v-img :src="cdnUrl+'/products/'+item.image" height="60px" width="60px" style="margin: 0 auto"></v-img>
                                {{ item.name }}
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="2"
                                    class="text-center"
                            >
                                ${{ item.value | number_format_real }}
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="2"
                                    class="text-center"
                            >
                                {{ item.qty }}x
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="2"
                                    class="text-center"
                            >
                                ${{ item.value*item.qty | number_format_real }}
                            </v-col>
                            <v-col cols="12">
                                <v-divider :key="index+'a'"></v-divider>
                            </v-col>
                        </v-row>
                        <v-row style="font-weight: bold;" v-if="order.tax">
                            <v-col
                                    cols="12"
                                    class="font-weight-bold title"
                            >
                                <span class="float-right">Total Products: ${{ order.subtotal | number_format_real}}</span>
                            </v-col>
                        </v-row>
                        <v-row style="font-weight: bold;" v-if="order.tax">
                            <v-col
                                    cols="12"
                                    class="font-weight-bold title"
                            >
                                <span class="float-right">Tax: ${{ order.tax | number_format_real}}</span>
                            </v-col>
                        </v-row>
                        <v-row style="font-weight: bold;" v-if="order.shipping">
                            <v-col
                                    cols="12"
                                    class="font-weight-bold title"
                            >
                                <span class="float-right">Shipping: ${{ order.shipping | number_format_real}}</span>
                            </v-col>
                        </v-row>
                        <v-row style="font-weight: bold;" v-else>
                            <v-col
                                    cols="12"
                                    class="font-weight-bold title"
                            >
                                <span class="float-right">Shipping: <span>FREE</span></span>
                            </v-col>
                        </v-row>
                        <v-row style="font-weight: bold;">
                            <v-col
                                    cols="12"
                                    class="font-weight-bold title"
                            >
                                <span class="float-right">Total: ${{ order.total | number_format_real}}</span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            cart: { type: Object },
            appUrl: { type: String },
            cdnUrl: { type: String },
        },
        metaInfo () {
            return {
                title: 'PPS Healthcare - Thanks Page',
                meta: [
                    {description: 'PPS Healthcare - Thanks Page'},
                    {keywords: 'PPS Healthcare - Thanks Page'}
                ]
            }
        },

        data () {
            return {
                paypal: {
                    sandbox: 'AXfY2yRIPfPl-YeQ3-0wAsuoBft5FLAHZaWZVsk2er4rcC3z_EjQAdm6DmwdwOvQ3SbqUDnGN1eUIua3',
                    production: 'AXfY2yRIPfPl-YeQ3-0wAsuoBft5FLAHZaWZVsk2er4rcC3z_EjQAdm6DmwdwOvQ3SbqUDnGN1eUIua3'
                },
                myStyle: {
                    layout: 'vertical',
                    size:  'responsive',
                    shape: 'pill',
                    color: 'gold'
                },
                experienceOptions: {
                    input_fields: {
                        no_shipping: 1
                    }
                },
                loading:{
                    general:true
                },
                customer:{
                    id:"",
                    email:"",
                    name:"",
                    password:"",
                    telephone:"",
                    cpf:""
                },
                address:{
                    zipcode:'',
                    address:'',
                    city:'',
                    state:'',
                    gatecode:'',
                    neighborhood:'',
                    number:'',
                    complement:'',
                    country:'USA',
                },
                order:{
                    id:"",
                    status:1,
                    status_en:"",
                    status_pt:"",
                    status_es:"",
                    subtotal:"",
                    tax:"",
                    shipping:"",
                    total:"",
                },
                products:{},
                productsPaypal:[]
            }
        },
        methods:{
            init(){
                this.$http.get(this.appUrl+"/store/order/"+this.$route.params.order).then(response =>{
                    this.loading.general = false;

                    this.customer.id = response.data.id_customer;
                    this.customer.name = response.data.name;

                    this.order.id = String(response.data.id);
                    this.order.status = response.data.status;
                    this.order.name_status = response.data.name_status;
                    this.order.subtotal = response.data.subtotal;
                    this.order.tax = response.data.tax;
                    this.order.shipping = response.data.shipping;
                    this.order.total = String(response.data.total);

                    this.address.zipcode = response.data.zipcode;
                    this.address.address = response.data.endereco;
                    this.address.city = response.data.cidade;
                    this.address.state = response.data.estado;
                    this.address.gatecode = response.data.gatecode;
                    this.address.neighborhood = response.data.bairro;
                    this.address.number = response.data.numero;
                    this.address.complement = response.data.complemento;
                    this.address.country = response.data.pais;

                    this.products = response.data.products;

                    for(let i =0;i < this.products.length; i++){
                        console.log(this.products[i]);
                        let j = {
                            name: this.products[i].name,
                            unit_amount: {value: this.products[i].value, currency_code: 'USD'},
                            quantity: this.products[i].qty,
                            sku: this.products[i].product
                        };
                        this.productsPaypal.push(j);
                    }
                });
            },
            setLoaded: function() {
                this.loaded = true;
                window.paypal
                    .Buttons({
                        style:{
                            layout: 'vertical',  // horizontal | vertical
                            size:   'responsive',    // medium | large | responsive
                            shape:  'pill',      // pill | rect
                            color:  'gold'       // gold | blue | silver | white | black
                        },
                        createOrder: (data, actions) => {
                            return actions.order.create({
                                purchase_units: [
                                    {
                                        amount: {
                                            currency_code: "USD",
                                            value: this.order.total,
                                            breakdown: {
                                                item_total: {value: this.order.subtotal, currency_code: 'USD'},
                                                tax_total: {value: this.order.tax, currency_code: 'USD'},
                                                shipping: {value: this.order.shipping, currency_code: 'USD'},

                                            },
                                        },
                                        description: "Order PPSHealthcare "+this.order.id,
                                        shipping: {
                                            "address": {
                                                "address_line_1": this.address.address,
                                                "address_line_2": "",
                                                "admin_area_2": this.address.city,
                                                "admin_area_1": this.address.state,
                                                "postal_code": this.address.zipcode,
                                                "country_code": "US"
                                            }
                                        },
                                        items: this.productsPaypal
                                    }
                                ],
                            });
                        },
                        onApprove: async (data, actions) => {
                            const order = await actions.order.capture();
                            this.updateOrder(order.id);
                        },
                        onError: err => {
                            console.log(err);
                        }
                    })
                    .render(this.$refs.paypal);
            },
            updateOrder(paypal){
                console.log(paypal)
                var arr = {
                    paypal:paypal,
                    order:this.order.id
                };
                arr = JSON.stringify(arr);
                this.$http.post(this.appUrl+"/store/cart/aprove",arr).then(response => {
                    console.log(response.data);
                    this.init();
                });
            }
        },
        mounted(){
            this.$emit('showCart');
            this.init();
            const script = document.createElement("script");
            script.src =
                "https://www.paypal.com/sdk/js?client-id=AXfY2yRIPfPl-YeQ3-0wAsuoBft5FLAHZaWZVsk2er4rcC3z_EjQAdm6DmwdwOvQ3SbqUDnGN1eUIua3&locale=en_US";
            script.addEventListener("load", this.setLoaded);
            document.body.appendChild(script);
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>